import { render, staticRenderFns } from "./HistoricoEquipoAsignadoTableComponent.vue?vue&type=template&id=7f050878&scoped=true"
import script from "./HistoricoEquipoAsignadoTableComponent.vue?vue&type=script&lang=js"
export * from "./HistoricoEquipoAsignadoTableComponent.vue?vue&type=script&lang=js"
import style0 from "./HistoricoEquipoAsignadoTableComponent.vue?vue&type=style&index=0&id=7f050878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f050878",
  null
  
)

export default component.exports